import { useState, useRef, useEffect, useCallback } from 'react'

export const useCooldown = () => {
  const [seconds, setSeconds] = useState(0)
  const timerRef = useRef(null)

  const start = useCallback((initialSeconds = 60) => {
    clearInterval(timerRef.current)
    setSeconds(initialSeconds)
    timerRef.current = setInterval(() => {
      setSeconds(prev => {
        if (prev <= 1) {
          clearInterval(timerRef.current)
          return 0
        }
        return prev - 1
      })
    }, 1000)
  }, [])

  useEffect(() => () => clearInterval(timerRef.current), [])

  return [seconds, start]
}
